//电子围栏
export default `
uniform vec4 color;
uniform float count;
czm_material czm_getMaterial(czm_materialInput materialInput)
{
  czm_material material = czm_getDefaultMaterial(materialInput);\n\
  vec2 st = materialInput.st;\n\
  vec4 colorImage = texture(image, vec2(fract(count*st.s+time),fract(st.t)));\n\
  vec4 fragColor;\n\
  fragColor.rgb = color.rgb / 1.0;\n\
  fragColor = czm_gammaCorrect(fragColor);\n\
  // material.diffuse = colorImage.rgb;\n\
  // material.alpha = colorImage.a;\n\
  // material.emission = fragColor.rgb;\n\
  material.alpha = colorImage.a * color.a;\n\
  material.diffuse = color.rgb;\n\
  material.emission = fragColor.rgb;\n\
  return material;\n\
}                                 
 `